import { createFileRoute } from '@tanstack/react-router';
import { cacheHeadersFor, experimentalRoutes } from '@/analytics';
import { AcademicLandingPage } from '@/components/astro/pages/academic-landing-page';
import { academicSeo } from '@/components/astro/pages/academic-seo';
import { normalizeCanonicalUrl } from '@/seo/canonical';
import { seo } from '@/seo/seo';

const ANALYTICS = experimentalRoutes['/_marketing/fb/academic'];

/**
 * `/fb/academic` — the Meta-ads academic landing URL, inherited from the
 * original Astro site (`apps/listening-astro/src/pages/fb/academic.astro`).
 * The `/fb/` prefix is a per-channel landing convention from that era; its
 * siblings (`/fb/create-your-account`, `/de/…`, `/fr/…`) were long ago
 * collapsed into redirects to `/`.
 *
 * Renders the same page as `/academic` (it was branched from that file in
 * `e82817e63`, and the two must not drift) and runs the same experiment arm
 * assignment. Both URLs must bucket identically — if they did not, the arm a
 * visitor saw would depend on which URL the ad happened to use, which is the
 * confound the experiment exists to eliminate.
 *
 * The canonical points at `/academic` so the two don't compete as duplicate
 * content — this URL still serves ads normally, it just doesn't ask to be
 * indexed in its own right.
 */
export const Route = createFileRoute('/_marketing/fb/academic')({
  staticData: { analytics: ANALYTICS },
  headers: cacheHeadersFor(ANALYTICS),
  head: () => ({
    meta: [...seo(academicSeo)],
    links: [{ rel: 'canonical', href: normalizeCanonicalUrl('/academic') }],
  }),
  component: AcademicLandingPage,
});
